import type { RefObject } from 'react'
import clsx from 'clsx'
import { IconButton } from '@features/shared/components/IconButton'
import { CloseIcon, SlidersIcon } from '@features/shared/icons/icons'
import { SearchIcon } from '../SearchIcons'

interface GlobalSearchInputBarProps {
  /** Matches the header search bar the palette opens over. */
  height: number
  inputRef: RefObject<HTMLInputElement>
  value: string
  onChange: (value: string) => void
  onClear: () => void
  matchButtonRef: RefObject<HTMLButtonElement>
  matchPanelOpen: boolean
  onToggleMatchPanel: () => void
}

/** The palette's search box, its clear button, and the search-parameters button. */
export function GlobalSearchInputBar({
  height,
  inputRef,
  value,
  onChange,
  onClear,
  matchButtonRef,
  matchPanelOpen,
  onToggleMatchPanel,
}: GlobalSearchInputBarProps) {
  return (
    <div
      className="border-default flex shrink-0 items-center gap-2 border-b px-3"
      style={{ height }}
    >
      <SearchIcon className="shrink-0 text-muted" />
      <input
        ref={inputRef}
        type="text"
        className="text-default placeholder:text-muted h-6 w-full bg-transparent text-sm outline-none"
        placeholder="Search anything..."
        aria-label="Search across everything"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value.length > 0 && (
        <>
          <IconButton
            wrapperClassName="shrink-0"
            className="inline-flex h-6 w-6 items-center justify-center rounded text-muted transition-colors hover:bg-muted hover:text-subtle"
            onClick={onClear}
            label="Clear search"
          >
            <CloseIcon size={12} />
          </IconButton>
          <span className="h-4 w-px shrink-0 bg-[color:var(--border-default)]" aria-hidden="true" />
        </>
      )}
      <button
        ref={matchButtonRef}
        type="button"
        className={clsx(
          'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded transition-colors',
          matchPanelOpen ? 'bg-muted text-default' : 'text-muted hover:bg-muted hover:text-subtle'
        )}
        onClick={onToggleMatchPanel}
        aria-label="Search parameters"
        aria-expanded={matchPanelOpen}
      >
        <SlidersIcon size={14} />
      </button>
    </div>
  )
}
